// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../fichesalarie/listerubriques/listerubriquessalarie.ts" />
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import $ from "jquery";
import { mapState } from "vuex";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { EventBus } from "../../Controls/EventBus";
import { RubriqueDetailDto } from "../../../dto/GenApi.iNotPaie.Dto/RubriqueDetailDto";
import EventConstants from "../../Controls/EventConstants";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { TypeRegleSequenceCalculEnum } from "../../../dto/GenApi.iNotPaie.Dto/TypeRegleSequenceCalculEnum";
import { RegleSequenceCalculDto } from "../../../dto/GenApi.iNotPaie.Dto/RegleSequenceCalculDto";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { SequenceDto } from "../../../dto/GenApi.iNotPaie.Dto/SequenceDto";
import { RubriqueDto } from "../../../dto/GenApi.iNotPaie.Dto/RubriqueDto";

interface LigneAideALaSaisie {
	code?: string;
	libelle?: string,
	estVisibleFacteur1: boolean,
	estVisibleFacteur2: boolean,
	estVisibleResultante: boolean,
}

interface SequenceViewModel extends SequenceDto {
	DetailFacteur1: string;
	DetailFacteur2: string;
	DetailResultante: string;
	EstSelectionne: boolean;
	listeLignesAideALaSaisieFacteur1: LigneAideALaSaisie[];
	listeLignesAideALaSaisieFacteur2: LigneAideALaSaisie[];
	listeLignesAideALaSaisieResultante: LigneAideALaSaisie[];
}

@Component({
	computed: {
		...mapState("ParametersStore", ["storeVariableListeFonctions"])
	}
})
export default class ModalAjoutRubrique extends Vue {
	@Prop({ required: true })
	public rubriquesProps!: RubriqueDto[];

	@Prop({ required: true })
	public updateRubriqueIdProps!: number;

	public storeVariableListeFonctions!: ParametreDto[];

	public estAjout = false;
	public disabledArchivee = false;
	public rubrique: RubriqueDetailDto = {
    	Id: 0,
    	Modifiable: true,
    	EstVariable: false,
    	RetroactivitePosible: false,
    	NaturePatronale: false,
    	ListeSequence: [],
    	EstArchivee: false,
    	EstVisibleEtudePst: true,
    	EstVisiblePst: true
	};

	public listeSequencesViewModel: SequenceViewModel[] = [];

	public listeRubriquesMini: RubriqueDto[] = [];

	public codeNatureBulletin = "A";
	public codeNatureGeneral = "P";
	public codeNatureQualification = "S";

	public arrondis = ParametresInstance.listeArrondis;
	public operateurs = ParametresInstance.listeOperateurs;
	public listeReglesSequencesCalcul: RegleSequenceCalculDto[] = [];
	public regexEstVariable = new RegExp("");
	public regexEstVariableValide = new RegExp("");
	public listeLignesAideALaSaisie: LigneAideALaSaisie[] = [];

	public visibilitesOptions = {
		PasAccessible: "Pas accessible",
		AccessiblePasVisible: "Accessible mais pas visible",
		AccessibleVisible: "Accessible et visible"
	}

	public visibilitePST = this.visibilitesOptions.PasAccessible;
	public societeIsPST = false;
	public dataIsReady = false;

	public handleClickOutside(): void {
		this.$emit("close");
	}

	public async mounted(): Promise<void> {
		this.dataIsReady = false;
		await $("#modalAjoutRubrique").modal("show");

		if (this.storeVariableListeFonctions.length == 0) {
			await this.$store.dispatch("ParametersStore/fetchFonctions").catch((error: Error) => {
				NotificationServiceInstance.SendWarning(`Erreur lors de la récupération des fonctions : ${error.message}`);
			});
		}

		EventBus.$on(EventConstants.ALL_LISTES_LOADED, () => {
			this.arrondis = ParametresInstance.listeArrondis;
			this.operateurs = ParametresInstance.listeOperateurs;
		});

		await this.InitAsync();

		this.dataIsReady = true;
	}

	public async InitAsync(): Promise<void> {
		this.societeIsPST = ParametresInstance.isPst;

		this.estAjout = !(this.updateRubriqueIdProps > 0);
		this.rubriquesProps = JSON.parse(JSON.stringify(this.rubriquesProps.filter(l => !l.EstArchivee)));
    	await this.initAideALaSaisieAsync();

		if (!this.estAjout) {
			ServicesFactoryInstance.RubriqueService.getRubrique(this.updateRubriqueIdProps.toString(), async(data) => {
    			this.rubrique = data;
    			this.rubrique.ListeSequence = this.rubrique.ListeSequence.sort((a, b) => {
    				if (a.NumeroSequence != undefined && b.NumeroSequence != undefined) {
    					return a.NumeroSequence - b.NumeroSequence;
    				}

    				return 0;
				});

				if (this.rubrique.EstVisiblePst && this.rubrique.EstVisibleEtudePst) {
					this.visibilitePST = this.visibilitesOptions.AccessibleVisible;
				} else if (this.rubrique.EstVisiblePst && !this.rubrique.EstVisibleEtudePst) {
					this.visibilitePST = this.visibilitesOptions.AccessiblePasVisible;
				} else {
					this.visibilitePST = this.visibilitesOptions.PasAccessible;
				}

				this.initAllSequences();
				this.gestionLigne();

				if (data.EstArchivee) {
					this.disabledArchivee = this.rubriquesProps.filter((r) => r.CodeRubrique === data.CodeRubrique && r.CodeNature === data.CodeNature).some((r) => !r.EstArchivee);
				} else {
					this.disabledArchivee = false;
				}
    		});
    	} else {
    		this.rubrique = {
    			Id: 0,
    			Modifiable: true,
    			EstVariable: false,
    			RetroactivitePosible: false,
    			NaturePatronale: false,
    			ListeSequence: [],
    			EstArchivee: false,
    			EstVisibleEtudePst: false,
    			EstVisiblePst: false
			};

			this.listeSequencesViewModel = [];
			this.visibilitePST = this.visibilitesOptions.PasAccessible;
			this.gestionLigne();
		}
	}

	/// <summary>
	///     Initialise lles paramètrages liés aux règles de séquences de calcul.
	/// </summary>
	public async initAideALaSaisieAsync(): Promise<void> {
		this.listeReglesSequencesCalcul = await ParametresInstance.getListeReglesSequencesCalculAsync();
		this.initRegexVariables(this.listeReglesSequencesCalcul.filter(regle => regle.Type === TypeRegleSequenceCalculEnum.VariableDynamique && regle.Code).map(regle => regle.Code ?? ""));
		this.listeLignesAideALaSaisie = [];

		const listeReglesLieesAuxRubriques = this.listeReglesSequencesCalcul.filter(regle =>
			regle.Type === TypeRegleSequenceCalculEnum.Rubrique ||
            regle.Type === TypeRegleSequenceCalculEnum.RubriqueBulletin ||
            regle.Type === TypeRegleSequenceCalculEnum.RubriqueQualification ||
			regle.Type === TypeRegleSequenceCalculEnum.RubriqueGenerale ||
			regle.Type === TypeRegleSequenceCalculEnum.RubriqueBulletinElementVariable
		);

		const listeReglesLieesAuxFonctions = this.listeReglesSequencesCalcul.filter(regle =>
			regle.Type === TypeRegleSequenceCalculEnum.Fonction
		);

		this.listeLignesAideALaSaisie = [
			...listeReglesLieesAuxRubriques.flatMap(regle => this.getListeLignesAideALaSaisieFromRubriques(regle)),
			...listeReglesLieesAuxFonctions.flatMap(regle => this.getListeLignesAideALaSaisieFromFonctions(regle))
		];

		this.listeReglesSequencesCalcul.forEach(regle => {
			if (regle.Type === TypeRegleSequenceCalculEnum.Constante) {
				this.listeLignesAideALaSaisie.push(this.getLigneAideALaSaisieFromConstante(regle));
			} else if (regle.Type === TypeRegleSequenceCalculEnum.VariableDynamique) {
				this.listeLignesAideALaSaisie.push(this.getLigneAideALaSaisieFromVariable(regle));
			}
		});
	}

	/// <summary>
	///     Construit dynamiquement les regex des variables.
	/// </summary>
	public initRegexVariables(listeCodesVariables: string[]): void {
		if (!listeCodesVariables) {
			return;
		}

		// Commence par un des codes de variables.
		const regexVariable = `^(?:${listeCodesVariables.join("|")})`;
		this.regexEstVariable = new RegExp(regexVariable);

		// Commence par un des codes de variables suivi d'un nombre (Le nombre ne commence pas par 0 sauf le nombre 0 lui-même)
		const regexVariableValide = `^(?:${listeCodesVariables.join("|")})(0|[1-9]\\d*)$`;
		this.regexEstVariableValide = new RegExp(regexVariableValide);
	}

	/// <summary>
	///     Initialise toutes les lignes de séquence et affecte le détail de chaque champ.
	/// </summary>
	public initAllSequences(): void {
		if (!this.rubrique?.ListeSequence) {
			return;
		}

		this.listeSequencesViewModel = this.rubrique.ListeSequence.map(sequence => this.getSequenceViewModel(sequence));
	}

	/// <summary>
	///     Initialise le détail d'une ligne de séquence.
	/// </summary>
	public async initSequence(sequence: SequenceViewModel): Promise<void> {
		if (!sequence) {
			return;
		}

		const detailPromises = [
			// Les détails des facteurs et de la résultante.
			this.getDetailFromCode(sequence.Facteur1 ?? "", true, false, false),
			this.getDetailFromCode(sequence.Facteur2 ?? "", false, true, false),
			this.getDetailFromCode(sequence.Resultat ?? "", false, false, true)
		];
		const [detailFacteur1, detailFacteur2, detailResultante] = await Promise.all(detailPromises);

		sequence.DetailFacteur1 = detailFacteur1;
		sequence.DetailFacteur2 = detailFacteur2;
		sequence.DetailResultante = detailResultante;

		const listeAidesPromises = [
			// Les détails des facteurs et de la résultante.
			this.GetListeFiltreeLignesAideALaSaisie(sequence.Facteur1 ?? "", true, false, false, true),
			this.GetListeFiltreeLignesAideALaSaisie(sequence.Facteur2 ?? "", false, true, false, true),
			this.GetListeFiltreeLignesAideALaSaisie(sequence.Resultat ?? "", false, false, true, true)
		];
		const [listeAidesFacteur1, listeAidesFacteur2, listeAidesResultante] = await Promise.all(listeAidesPromises);

		sequence.listeLignesAideALaSaisieFacteur1 = listeAidesFacteur1;
		sequence.listeLignesAideALaSaisieFacteur2 = listeAidesFacteur2;
		sequence.listeLignesAideALaSaisieResultante = listeAidesResultante;
	}

	/// <summary>
	///     Construit et retourne une ligne d'aide à la saisie à partir d'une règle pour une constante.
	/// </summary>
	public getLigneAideALaSaisieFromConstante(regle: RegleSequenceCalculDto): LigneAideALaSaisie {
    	const ligneAideALaSaisie: LigneAideALaSaisie = {
    		code: regle.Code,
    		libelle: regle.Description,
    		estVisibleFacteur1: regle.EstVisibleFacteur1,
    		estVisibleFacteur2: regle.EstVisibleFacteur2,
    		estVisibleResultante: regle.EstVisibleResultante
    	};

    	return ligneAideALaSaisie;
	}

	/// <summary>
	///     Construit et retourne la liste des aides à la saisie pour une règle liée à une rubrique.
	/// </summary>
	public getListeLignesAideALaSaisieFromRubriques(regle: RegleSequenceCalculDto): LigneAideALaSaisie[] {
    	const listeLignesAideALaSaisie: LigneAideALaSaisie[] = [];

    	let listeRubriqueFiltree: RubriqueDto[] = [];
    	switch (regle.Type) {
    		case TypeRegleSequenceCalculEnum.Rubrique:
    			listeRubriqueFiltree = this.rubriquesProps;
    			break;
    		case TypeRegleSequenceCalculEnum.RubriqueBulletin:
				listeRubriqueFiltree = this.rubriquesProps.filter(r => r.CodeNature === "A");
    			break;
    		case TypeRegleSequenceCalculEnum.RubriqueQualification:
				listeRubriqueFiltree = this.rubriquesProps.filter(r => r.CodeNature === "S");
    			break;
    		case TypeRegleSequenceCalculEnum.RubriqueGenerale:
				listeRubriqueFiltree = this.rubriquesProps.filter(r => r.CodeNature === "P");
				break;
			case TypeRegleSequenceCalculEnum.RubriqueBulletinElementVariable:
				listeRubriqueFiltree = this.rubriquesProps.filter(r => r.CodeNature === "A" && r.EstVariable);
				break;
    	}

    	listeRubriqueFiltree.forEach(r => {
    		listeLignesAideALaSaisie.push(this.getLigneAideALaSaisieFromRubrique(regle, r));
    	});

    	return listeLignesAideALaSaisie;
	}

	/// <summary>
	///     Construit dynamiquement les regex des variables.
	/// </summary>
	public getLigneAideALaSaisieFromRubrique(regle: RegleSequenceCalculDto, rubrique: RubriqueDto): LigneAideALaSaisie {
    	const ligneAideALaSaisie: LigneAideALaSaisie = {
    		code: (regle.Code || "") + (rubrique.CodeRubrique || ""),
    		libelle: rubrique.LibelleRubrique,
    		estVisibleFacteur1: regle.EstVisibleFacteur1,
    		estVisibleFacteur2: regle.EstVisibleFacteur2,
    		estVisibleResultante: regle.EstVisibleResultante
    	};

    	return ligneAideALaSaisie;
	}

	/// <summary>
	///     Construit et retourne la liste des aides à la saisie pour une règle liée à une variable.
	/// </summary>
	public getLigneAideALaSaisieFromVariable(regle: RegleSequenceCalculDto): LigneAideALaSaisie {
    	const ligneAideALaSaisie: LigneAideALaSaisie = {
    		code: regle.Code,
    		libelle: regle.Description,
    		estVisibleFacteur1: regle.EstVisibleFacteur1,
    		estVisibleFacteur2: regle.EstVisibleFacteur2,
    		estVisibleResultante: regle.EstVisibleResultante
    	};

    	return ligneAideALaSaisie;
	}

	/// <summary>
	///     Construit et retourne la liste des aides à la saisie pour une règle liée à une fonction.
	/// </summary>
	public getListeLignesAideALaSaisieFromFonctions(regle: RegleSequenceCalculDto): LigneAideALaSaisie[] {
    	const listeLignesAideALaSaisie: LigneAideALaSaisie[] = [];
		this.storeVariableListeFonctions.forEach(f => listeLignesAideALaSaisie.push(this.getLigneAideALaSaisieFromFonction(regle, f)));

    	return listeLignesAideALaSaisie;
	}

	/// <summary>
	///     Construit et retourne une ligne d'aide à la saisie pour une règle liée à une fonction.
	/// </summary>
	public getLigneAideALaSaisieFromFonction(regle: RegleSequenceCalculDto, fonction: ParametreDto): LigneAideALaSaisie {
    	const ligneAideALaSaisie: LigneAideALaSaisie = {
    		code: (regle.Code || "") + (fonction.Code || ""),
    		libelle: fonction.Libelle,
    		estVisibleFacteur1: regle.EstVisibleFacteur1,
    		estVisibleFacteur2: regle.EstVisibleFacteur2,
    		estVisibleResultante: regle.EstVisibleResultante
    	};

    	return ligneAideALaSaisie;
	}

	/// <summary>
	///     Changement du Facteur 1 d'une séquence (Input Change).
	/// </summary>
	public onSequenceChangeCodeFacteur1(sequence: SequenceViewModel): void {
		if (!sequence) {
			return;
		}

		if (sequence.Facteur1) {
			sequence.Facteur1 = sequence.Facteur1.toUpperCase();
		}

		// Filtre la liste des lignes d'aide à la saisie pour le facteur 1.
		sequence.listeLignesAideALaSaisieFacteur1 = this.GetListeFiltreeLignesAideALaSaisie(sequence.Facteur1 ?? "", true, false, false, true);
	}

	/// <summary>
	///     Changement du Facteur 2 d'une séquence (Input Change).
	/// </summary>
	public onSequenceChangeCodeFacteur2(sequence: SequenceViewModel): void {
		if (!sequence) {
			return;
		}

		if (sequence.Facteur2) {
			sequence.Facteur2 = sequence.Facteur2.toUpperCase();
		}

		// Filtre la liste des lignes d'aide à la saisie pour le facteur 2.
		sequence.listeLignesAideALaSaisieFacteur2 = this.GetListeFiltreeLignesAideALaSaisie(sequence.Facteur2 ?? "", false, true, false, true);
	}

	/// <summary>
	///     Changement de la Résultante  d'une séquence (Input Change).
	/// </summary>
	public onSequenceChangeCodeResultante(sequence: SequenceViewModel): void {
		if (!sequence) {
			return;
		}

		if (sequence.Resultat) {
			sequence.Resultat = sequence.Resultat.toUpperCase();
		}

		// Filtre la liste des lignes d'aide à la saisie pour la résultante.
		sequence.listeLignesAideALaSaisieResultante = this.GetListeFiltreeLignesAideALaSaisie(sequence.Resultat ?? "", false, false, true, true);
	}

	/// <summary>
	///     Changement du Facteur 1 d'une séquence (Lost Focus).
	/// </summary>
	public onFacteur1Change(sequence: SequenceViewModel): void {
    	if (!sequence) {
    		return;
    	}

		if (sequence.Facteur1) {
			sequence.Facteur1 = sequence.Facteur1.toUpperCase();
		}

		// Affectation du détail pour le facteur 1.
		sequence.DetailFacteur1 = this.getDetailFromCode(sequence.Facteur1 ?? "", true, false, false);

		this.gestionLigne();
	}

	/// <summary>
	///     Changement du Facteur 2 d'une séquence (Lost Focus).
	/// </summary>
	public onFacteur2Change(sequence: SequenceViewModel): void {
		if (!sequence) {
			return;
		}

		if (sequence.Facteur2) {
			sequence.Facteur2 = sequence.Facteur2.toUpperCase();
		}

		// Affectation du détail pour le facteur 2.
		sequence.DetailFacteur2 = this.getDetailFromCode(sequence.Facteur2 ?? "", false, true, false);
	}

	/// <summary>
	///     Changement de la Résultante d'une séquence (Lost Focus).
	/// </summary>
	public onResultanteChange(sequence: SequenceViewModel): void {
		if (!sequence) {
			return;
		}

		if (sequence.Resultat) {
			sequence.Resultat = sequence.Resultat.toUpperCase();
		}

		// Affectation du détail pour la Résultante.
		sequence.DetailResultante = this.getDetailFromCode(sequence.Resultat ?? "", false, false, true);
	}

	/// <summary>
	///     Retourne un détail à partir du code et d'un filtre à appliquer sur la liste des aides à la saisie.
	/// </summary>
	public getDetailFromCode(code: string, estFacteur1: boolean, estFacteur2: boolean, estResultante: boolean): string {
		if (code === "" || code === undefined) {
			// Cas d'un code vide.

			return "";
		}

		if (this.estValeurEnDur(code)) {
			// Cas des valeurs en dur.

			return "Valeur en dur";
		}

		if (this.estVariableDynamique(code)) {
			// Cas des variables dynamiques.

			return this.estVariableDynamiqueCorrecte(code)
				? `Variable ${code}`
				: "Variable non valide";
		}

		const listeLignesAideALaSaisie = this.GetListeFiltreeLignesAideALaSaisie(code, estFacteur1, estFacteur2, estResultante, false);

		return listeLignesAideALaSaisie.length === 0
			? "#erreur# Aucun résultat"
			: listeLignesAideALaSaisie.length > 1
				? "#erreur# Trop de résultats"
				: listeLignesAideALaSaisie[0].libelle ?? "";
	}

	/// <summary>
	///     Applique un filtre sur la liste des aides à la saisie et retourne la liste filtrée.
	/// </summary>
	public GetListeFiltreeLignesAideALaSaisie(saisie: string, estFacteur1: boolean, estFacteur2: boolean, estResultante: boolean, estFiltreCommencantPar: boolean): LigneAideALaSaisie[] {
		const listeLignesAideALaSaisie: LigneAideALaSaisie[] = [];

		if (saisie) {
			// La saisie n'est pas vide.

			listeLignesAideALaSaisie.push(...this.listeLignesAideALaSaisie.filter(l =>
				((l.estVisibleFacteur1 && estFacteur1) ||
                        (l.estVisibleFacteur2 && estFacteur2) ||
                        (l.estVisibleResultante && estResultante)) && (estFiltreCommencantPar ? l.code?.startsWith(saisie) : l.code === saisie)));
		}

		return listeLignesAideALaSaisie;
	}

	/// <summary>
	///     La saisie est une valeur en dur (Oui / Non).
	/// </summary>
	public estValeurEnDur(code: string): boolean {
		const regex = /^-?\d*\.?\d+$/;

		return regex.test(code);
	}

	/// <summary>
	///     La saisie démarre comme une variable dynamique (Oui / Non).
	/// </summary>
	public estVariableDynamique(code: string): boolean {
		return this.regexEstVariable.test(code);
	}

	/// <summary>
	///     La saisie est une variable dynamique correcte (Oui / Non).
	/// </summary>
	public estVariableDynamiqueCorrecte(code: string): boolean {
		return this.regexEstVariableValide.test(code);
	}

	public gestionLigne(): void {
		if (!this.listeSequencesViewModel) {
			return;
		}

		if (this.listeSequencesViewModel.length === 0 ||
            (this.listeSequencesViewModel[this.listeSequencesViewModel.length - 1].Facteur1?.length ?? 0) > 0) {
			this.listeSequencesViewModel.push(this.getSequenceViewModel());
			this.ordonnerNumeroSequence();
		}

		this.listeSequencesViewModel = this.listeSequencesViewModel.filter(sequence => (sequence.Facteur1 != "") || (sequence.Facteur2 != "") || (sequence.Resultat != "") || this.listeSequencesViewModel.indexOf(sequence) == this.listeSequencesViewModel.length - 1);
	}

	public annuler(): void {
		$("#modalAjoutRubrique").modal("hide");
		this.$emit("close");
	}

	public save(): boolean | void {
    	const errorMessage: string[] = [];
    	if (this.rubrique.CodeRubrique == undefined) {
    		errorMessage.push("Le Code est obligatoire");
		}
		if (this.rubriquesProps.filter(r => r.CodeRubrique == this.rubrique.CodeRubrique && r.CodeNature == this.rubrique.CodeNature && !r.EstArchivee).length > 0 && this.estAjout) {
            errorMessage.push("Le Code est déjà utilisé.");
        }
    	if (this.rubrique.LibelleRubrique == undefined) {
    		errorMessage.push("Le Libelle Rubrique est obligatoire");
    	}
    	if (this.rubrique.CodeNature == undefined) {
    		errorMessage.push("Le Code Nature est obligatoire");
    	}
    	if (this.rubrique.NumeroSequence == undefined) {
    		errorMessage.push("Le Numero de Sequence est obligatoire");
        }
        if (this.rubrique.DefaultValue == undefined && this.rubrique.CodeNature == 'P') {
            errorMessage.push("La Valeur est obligatoire.");
        }
    	if (errorMessage.length > 0) {
    		for (let i = 0; i < errorMessage.length; i++) {
    			NotificationServiceInstance.SendFailed(errorMessage[i]);
    		}

    		return false;
    	}

    	if (!this.checkSequences() ||
            !this.checkChampAssocie() ||
            !this.checkCodeQualif() ||
            !this.checkCumulCalcul() ||
            !this.checkCumulRetro()) {
    		NotificationServiceInstance.SendFailed("Le modèle n'est pas valide");

    		return false;
		}

		this.MapListeSequencesDto();

    	if (!this.estAjout) {
    		ServicesFactoryInstance.RubriqueService.updateRubrique(this.rubrique, () => {
    			this.annuler();
    			NotificationServiceInstance.SendSuccess("La rubrique a été modifiée avec succès.");
    			this.$emit("refresh");
    		});
        } else {
    		ServicesFactoryInstance.RubriqueService.addRubrique(this.rubrique, () => {
    			this.annuler();
    			NotificationServiceInstance.SendSuccess("La rubrique a été ajoutée avec succès.");
    			this.$emit("refresh");
    		});
    	}
	}

	public checkSequences(): boolean {
		if (this.rubrique.CodeNature !== this.codeNatureBulletin) {
			// Pas de séquence pour les rubriques de nature autre que bulletin.
			return true;
		}

		for (const seq of this.listeSequencesViewModel) {
    		if (!this.checkLibelleRubriqueFacteur1(seq.Facteur1)) {
    			NotificationServiceInstance.SendFailed("Une séquence contient une erreur : " + seq.Facteur1);

    			return false;
    		}

    		if (!this.checkLibelleRubriqueFacteur2(seq.Facteur2)) {
    			NotificationServiceInstance.SendFailed("Une séquence contient une erreur : " + seq.Facteur2);

    			return false;
    		}
    		if (!this.checkLibelleRubriqueResultat(seq.Resultat)) {
    			NotificationServiceInstance.SendFailed("Une séquence contient une erreur : " + seq.Resultat);

    			return false;
    		}
    	}

    	return true;
	}

	public checkChampAssocie(): boolean {
    	if (this.rubrique.CodeNature !== this.codeNatureBulletin || !this.rubrique.ChampAssocie) {
    		return true;
    	}

    	if (this.rubriquesProps.filter(r => r.CodeRubrique == this.rubrique.ChampAssocie).length > 0) {
    		return true;
    	}

    	NotificationServiceInstance.SendFailed("Le champ associé n'est pas une rubrique valide.");

    	return false;
	}

	public checkCumulCalcul(): boolean {
    	if (this.rubrique.CodeNature !== this.codeNatureBulletin || !this.rubrique.CodeRubriqueCumul) {
    		return true;
    	}

    	if (this.rubriquesProps.filter(r => r.CodeRubrique == this.rubrique.CodeRubriqueCumul).length > 0) {
    		return true;
    	}

    	NotificationServiceInstance.SendFailed("Le cumul calcul n'est pas une rubrique valide.");

    	return false;
	}

	public checkCumulRetro(): boolean {
    	if (this.rubrique.CodeNature !== this.codeNatureBulletin || !this.rubrique.CumulRetro) {
    		return true;
    	}

    	if (this.rubriquesProps.filter(r => r.CodeRubrique == this.rubrique.CumulRetro).length > 0) {
    		return true;
    	}

    	NotificationServiceInstance.SendFailed("Le cumul retro n'est pas une rubrique valide.");

    	return false;
	}

	public checkCodeQualif(): boolean {
    	if (this.rubrique.CodeNature !== this.codeNatureBulletin || !this.rubrique.CodeRubriqueQualif) {
    		return true;
    	}

    	if (this.rubriquesProps.filter(r => r.CodeRubrique == this.rubrique.CodeRubriqueQualif).length > 0) {
    		return true;
    	}

    	NotificationServiceInstance.SendFailed("Le code qualification n'est pas une rubrique valide.");

    	return false;
	}

	public getLibelleRubriqueFacteur(facteur?: string): string | undefined {
    	if (facteur == undefined) {
    		return "";
    	}
    	if (!this.checkLibelleRubriqueFacteur1(facteur)) {
    		return "";
    	}

    	if (facteur.substring(0, 1) == "EX") {
    		const valeurSuiviFacteurStr = facteur.substring(2);

    		return this.rubriquesProps.filter(r => r.CodeRubrique == valeurSuiviFacteurStr)[0].LibelleRubrique;
    	} else if (facteur.substring(0, 2) == "NEX") {
    		const valeurSuiviFacteurStr = facteur.substring(3);

    		return this.rubriquesProps.filter(r => r.CodeRubrique == valeurSuiviFacteurStr)[0].LibelleRubrique;
    	} else if (facteur.substring(0, 1) == "P") {
    		const codeRubrique = facteur.substring(1);

    		return this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "P")[0].LibelleRubrique;
    	} else if (facteur.substring(0, 1) == "K") {
    		const codeRubrique = facteur.substring(1);

    		return this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "A")[0].LibelleRubrique;
    	} else if (facteur.substring(0, 1) == "V") {
    		const codeRubrique = facteur.substring(1);

    		return this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "A")[0].LibelleRubrique;
    	} else if (facteur.substring(0, 1) == "C") {
    		const codeRubrique = facteur.substring(1);

    		return this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "A")[0].LibelleRubrique;
    	} else if (facteur.substring(0, 1) == "S") {
    		const codeRubrique = facteur.substring(1);

    		return this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "S")[0].LibelleRubrique;
    	}

    	return "";
	}

	public checkLibelleRubriqueFacteur1(facteur?: string): boolean {
    	if (facteur == undefined || facteur == "") {
    		return true;
    	}

    	const valeurFacteur = Number(facteur);
    	if (typeof valeurFacteur == "number" && !Number.isNaN(valeurFacteur)) {
    		return true;
    	} else {
    		if (facteur.substring(0, 5) == "MSUSP") {
    			return true;
    		} else if (facteur.substring(0, 4) == "MOIS") {
    			return true;
    		} else if (facteur.substring(0, 6) == "RTMOIS") {
    			return true;
    		} else if (facteur.substring(0, 4) == "DEPA") {
    			return true;
    		} else if (facteur.substring(0, 4) == "ENTR") {
    			return true;
    		} else if (facteur.substring(0, 6) == "CGMOIS") {
    			return true;
    		} else if (facteur.substring(0, 6) == "CGRECO") {
    			return true;
    		} else if (facteur.substring(0, 6) == "CGJOUR") {
    			return true;
    		} else if (facteur.substring(0, 1) == "T") {
    			const valeurSuiviFacteur = Number(facteur.substring(1));

    			return !isNaN(valeurSuiviFacteur);
    		} else if (facteur.substring(0, 4) == "COND") {
    			const valeurSuiviFacteur = Number(facteur.substring(4));

    			return !isNaN(valeurSuiviFacteur);
    		} else if (facteur.substring(0, 5) == "NCOND") {
    			const valeurSuiviFacteur = Number(facteur.substring(5));

    			return !isNaN(valeurSuiviFacteur);
    		} else if (facteur.substring(0, 3) == "EXV") {
    			const codeRubrique = facteur.substring(3);

    			return this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "A").length > 0;
    		} else if (facteur.substring(0, 2) == "EX") {
    			const valeurSuiviFacteurStr = facteur.substring(2);

    			return this.rubriquesProps.filter(r => r.CodeRubrique == valeurSuiviFacteurStr).length > 0;
    		} else if (facteur.substring(0, 4) == "NEXV") {
    			const valeurSuiviFacteurStr = facteur.substring(4);

    			return this.rubriquesProps.filter(r => r.CodeRubrique == valeurSuiviFacteurStr).length > 0;
    		} else if (facteur.substring(0, 3) == "NEX") {
    			const valeurSuiviFacteurStr = facteur.substring(3);

    			return this.rubriquesProps.filter(r => r.CodeRubrique == valeurSuiviFacteurStr).length > 0;
    		} else if (facteur.substring(0, 1) == "F") {
    			const valeurSuiviFacteurStr = facteur.substring(1);

				return this.storeVariableListeFonctions.filter(f => f.Code == valeurSuiviFacteurStr).length > 0;
    		} else if (facteur.substring(0, 1) == "P") {
    			const codeRubrique = facteur.substring(1);

    			return this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "P").length > 0;
    		} else if (facteur.substring(0, 1) == "K") {
    			const codeRubrique = facteur.substring(1);

    			return this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "A").length > 0;
    		} else if (facteur.substring(0, 1) == "V") {
    			const codeRubrique = facteur.substring(1);

    			return this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "A").length > 0;
    		} else if (facteur.substring(0, 1) == "C") {
    			const codeRubrique = facteur.substring(1);

    			return this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "A").length > 0;
    		} else if (facteur.substring(0, 1) == "S") {
    			const codeRubrique = facteur.substring(1);

    			return this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "S").length > 0;
    		}
    	}

    	return false;
	}

	public checkLibelleRubriqueFacteur2(facteur?: string): boolean {
    	if (facteur == undefined || facteur == "") {
    		return true;
    	}

    	switch (facteur) {
    		case "A001": {
    			return true;
    		}
    		case "A002": {
    			return true;
    		}
    		case "A003": {
    			return true;
    		}
    	}

    	return this.checkLibelleRubriqueFacteur1(facteur);
	}

	public checkLibelleRubriqueResultat(facteur?: string): boolean {
    	if (facteur == undefined || facteur == "") {
    		return true;
    	}

    	switch (facteur.substring(0, 4)) {
    		case "FIN": {
    			return true;
    		}
    		case "COND": {
    			if (!isNaN(Number(facteur.substring(4)))) {
    				return true;
    			}
    			break;
    		}
    		case "T": {
    			if (!isNaN(Number(facteur.substring(1)))) {
    				return true;
    			}
    			break;
    		}
    		case "C": {
    			const codeRubrique = facteur.substring(1);
    			if (this.rubriquesProps.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "S").length > 0) {
    				return true;
    			}
    			break;
    		}
    	}

    	return this.checkLibelleRubriqueFacteur1(facteur);
	}

	public moveLignes(direction: string): void {
		const sequencesABouger = this.listeSequencesViewModel.filter(s => s.EstSelectionne);
    	if (sequencesABouger.length == 0) {
    		NotificationServiceInstance.SendInformation("Veuillez sélectionner au moins une séquence.");
    	}

    	let oldIndex = 0;
    	if (direction == "haut") {
    		// On replace les séquences
    		// Remonte les séquences d'un index
    		for (let i = 0; i < sequencesABouger.length; i++) {
    			// Quitte si la séquence est la première de la liste
				if (this.listeSequencesViewModel.indexOf(sequencesABouger[i]) == 0) {
    				return;
    			}
				oldIndex = this.listeSequencesViewModel.indexOf(sequencesABouger[i]);
				this.listeSequencesViewModel.splice(oldIndex, 1);
				this.listeSequencesViewModel.splice(oldIndex - 1, 0, sequencesABouger[i]);
    		}
    	} else if (direction == "bas") {
    		// On replace les séquences
    		// Redescend les séquences d'un index
    		for (let i = sequencesABouger.length - 1; i >= 0; i--) {
    			// Quitte si la séquence est la dernière de la liste
				if (this.listeSequencesViewModel.indexOf(sequencesABouger[i]) == this.listeSequencesViewModel.length - 1) {
    				return;
    			}
				oldIndex = this.listeSequencesViewModel.indexOf(sequencesABouger[i]);
				this.listeSequencesViewModel.splice(oldIndex, 1);
				this.listeSequencesViewModel.splice(oldIndex + 1, 0, sequencesABouger[i]);
    		}
    	}
    	this.ordonnerNumeroSequence();
	}

	public insertLigne(): void {
		if (!this.listeSequencesViewModel) {
			return;
		}

		if (this.listeSequencesViewModel.length === 0) {
			// Aucune ligne dans le tableau, on en crée une automatiquement.
			this.listeSequencesViewModel.push(this.getSequenceViewModel());

			return;
		}

		const sequencesWhereInsert = this.listeSequencesViewModel.filter(s => s.EstSelectionne);
    	if (sequencesWhereInsert.length == 0) {
    		NotificationServiceInstance.SendInformation("Veuillez sélectionner au moins une séquence.");
    	} else {
			// Insert la ligne
			this.listeSequencesViewModel.splice(this.listeSequencesViewModel.indexOf(sequencesWhereInsert[sequencesWhereInsert.length - 1]) + 1, 0, this.getSequenceViewModel());
    	}
    	this.ordonnerNumeroSequence();
	}

	public deleteLignes(): void {
		const sequencesToDelete = this.listeSequencesViewModel.filter(s => s.EstSelectionne);
    	if (sequencesToDelete.length == 0) {
    		NotificationServiceInstance.SendInformation("Veuillez sélectionner au moins une séquence.");
    	} else {
    		for (let i = 0; i < sequencesToDelete.length; i++) {
				this.listeSequencesViewModel.splice(this.listeSequencesViewModel.indexOf(sequencesToDelete[i]), 1);
    		}
    		this.ordonnerNumeroSequence();
    	}
	}

	public ordonnerNumeroSequence(): void {
		// On réordonne les numéros de séquence
		for (let i = 1; i <= this.listeSequencesViewModel.length; i++) {
			this.listeSequencesViewModel[i - 1].NumeroSequence = i * 10;
    	}
	}

	public filterDataList(value: string): void {
    	this.listeRubriquesMini = this.rubriquesProps.filter(r => (r.CodeRubrique + " / " + r.LibelleRubrique).toUpperCase().indexOf(value.toUpperCase()) >= 0).slice(0, 10);
	}

	public click_check(sequence: SequenceViewModel): void {
		if (!sequence ||
            !this.listeSequencesViewModel) {
			return;
		}

		const estSelectionne = sequence.EstSelectionne;

		this.listeSequencesViewModel.forEach(seq => {
			seq.EstSelectionne = false;
		});

		sequence.EstSelectionne = !estSelectionne;
	}

	public checkFormat(event: any): void {
    	if (event.key == ",") {
    		event.preventDefault();
    		event.target.value += ".";
    	}
	}

	public getLibelleNatureSelectionnee(): string {
		switch (this.rubrique.CodeNature) {
			case this.codeNatureBulletin:
				return "de type Bulletin";
			case this.codeNatureGeneral:
				return "de type Général";
			case this.codeNatureQualification:
				return "de type Qualification";
			default:
				return "";
		}
	}

	/// <summary>
	///     Retourne un SequenceViewModel avec le détails F1/F2/Résultante à partir d'un SequenceDto.
	///     Si le sequence est null, retourne un nouveau SequenceViewModel.
	/// </summary>
	public getSequenceViewModel(sequence?: SequenceDto): SequenceViewModel {
		const sequenceViewModel: SequenceViewModel = {
			Id: sequence?.Id ?? 0,
			NumeroSequence: sequence?.NumeroSequence ?? 0,
			Facteur1: sequence?.Facteur1 ?? "",
			Operateur: sequence?.Operateur ?? "",
			Facteur2: sequence?.Facteur2 ?? "",
			Resultat: sequence?.Resultat ?? "",
			TypeArrondi: sequence?.TypeArrondi ?? "",
			DetailFacteur1: "",
			DetailFacteur2: "",
			DetailResultante: "",
			listeLignesAideALaSaisieFacteur1: [],
			listeLignesAideALaSaisieFacteur2: [],
			listeLignesAideALaSaisieResultante: [],
			EstSelectionne: false

		};

		if (sequence) {
			this.initSequence(sequenceViewModel);
		}

		return sequenceViewModel;
	}

	public MapListeSequencesDto(): void {
		if (!this.rubrique) {
			return;
		}

		this.rubrique.ListeSequence = this.rubrique.CodeNature !== this.codeNatureBulletin
			? []
			: this.listeSequencesViewModel.map(s => this.GetSequencesDto(s));
	}

	public GetSequencesDto(sequence: SequenceViewModel): SequenceDto {
		const sequenceDto: SequenceDto = {
			Id: sequence.Id,
			IdRubriqueFK: this.rubrique.Id,
			NumeroSequence: sequence.NumeroSequence,
			Facteur1: sequence.Facteur1,
			Operateur: sequence.Operateur,
			Facteur2: sequence.Facteur2,
			Resultat: sequence.Resultat,
			TypeArrondi: sequence.TypeArrondi
		};

		return sequenceDto;
	}

	public changeVisibility(): void {
		switch (this.visibilitePST) {
			case this.visibilitesOptions.PasAccessible:
				this.rubrique.EstVisiblePst = false;
				this.rubrique.EstVisibleEtudePst = false;
				break;
			case this.visibilitesOptions.AccessiblePasVisible:
				this.rubrique.EstVisiblePst = true;
                this.rubrique.EstVisibleEtudePst = false;
				break;
			case this.visibilitesOptions.AccessibleVisible:
				this.rubrique.EstVisiblePst = true;
                this.rubrique.EstVisibleEtudePst = true;
                break;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/rubriques/modalAjoutRubrique/modalAjoutRubrique.ts